var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/modules/_html.js
// module id = 245
// module chunks = 168707334958949